<template>
  <div>
    <el-button size="mini" @click="closeHistory(1, {})" style="margin-bottom: 20px">返回</el-button>
    <el-table
        height="300"
        class="tableListValue"
        :data="tableData"
        style="width: 100%">
      <el-table-column
          prop="deployName"
          align="center"
          width="100"
          label="配置名称">
      </el-table-column>
      <el-table-column
          prop="canChannel"
          width="100"
          align="center"
          label="CAN通道">
        <template slot-scope="scope">
          {{canChannelObj[scope.row.canChannel]}}
        </template>
      </el-table-column>
      <el-table-column
          prop="dataType"
          width="100"
          align="center"
          label="数据类型">
      </el-table-column>
      <el-table-column
          prop="canId"
          width="100"
          align="center"
          label="ID(OX)">
      </el-table-column>
      <el-table-column
          prop="canType"
          width="100"
          align="center"
          label="ID类型">
        <template slot-scope="scope">
          {{canTypeObj[scope.row.canType]}}
        </template>
      </el-table-column>
      <el-table-column
          prop="startBit"
          width="100"
          align="center"
          label="起始位">
      </el-table-column>
      <el-table-column
          prop="bitLength"
          align="center"
          label="长度(bit)">
      </el-table-column>
      <el-table-column
          prop="trms"
          align="center"
          label="有效值(OX)">
      </el-table-column>
      <el-table-column
          prop="modifTime"
          align="center"
          width="150"
          label="配置时间">
      </el-table-column>
      <el-table-column
          prop="modifer"
          align="center"
          label="配置账号">
      </el-table-column>
      <el-table-column
          align="center"
          label="操作">
        <template slot-scope="scope">
          <el-link @click="closeHistory(2, scope.row)" :underline="false" type="primary" style="display:inline-block;font-weight: 700;margin-right: 10px">使用
          </el-link>
          <el-link @click="deleteHistory(scope.row)" :underline="false" type="primary" style="font-weight: 700">删除
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {getDeploy, deleteDeploy} from "../../../common/signalConfigurationApi";

export default {
  name: "historyConfiguration",
  data() {
    return {
      canChannelObj: {
        0: '通道0',
        1: '通道1',
      },
      canTypeObj: {
        0: '标准帧',
        1: '扩展帧',
      },
      currentPage: 1,
      pageSize: 100,
      total: 0,
      tableData: []
    }
  },
  created() {
    this.getDeploy()
  },
  methods: {
    // 获取列表
    async getDeploy() {
      this.tableLoadingType = true
      // try {
        const param = {
          pageNo: this.currentPage,
          pageSize: this.pageSize,
        }
      getDeploy(param).then(res=>{
        console.log(res)
          if (res.code === 200) {
            this.tableData = res.data
            this.total = res.total
            this.tableLoadingType = false
          } else {
            this.$notify.error({
              title: '错误提示',
              message: res.msg
            });
            this.tableLoadingType = false
          }
      }).catch(err=>{
        console.log(err)
      })
      //   const res = await getDeploy(param)
      //   if (res.code === 200) {
      //     this.tableData = res.data
      //     this.total = res.total
      //     this.tableLoadingType = false
      //   } else {
      //     this.$notify.error({
      //       title: '错误提示',
      //       message: res.msg
      //     });
      //     this.tableLoadingType = false
      //   }
      // } catch (e) {
      //   this.tableLoadingType = false
      //   console.log(e)
      // }
    },
    closeHistory(type, item) {
      this.$emit('closeHistory', {type, item})
    },
    deleteHistory(row) {

      console.log(row)
       deleteDeploy({id:row.id}).then(res=>{
        console.log(res)
        if (res.code===200){
          console.log('sadad')
          this.$notify.success({
                  title: '成功提示',
                  message: '删除成功'
          })
          this.getDeploy()
          // setTimeout(()=>{
          // console.log()

          // },1000)

        }
      }).catch(err=>{
        console.log(err)
      })
    },
    handleSizeChange() {
    },
    handleCurrentChange() {
    },
  }
}
</script>

<style scoped>
.pagination {
  margin-top: 10px;
  text-align: right;
}
</style>
<style scoped lang="scss">
.tableListValue {
  //滚动条的宽高
  ::-webkit-scrollbar {
    width: 1vh;
    height: 1vh;
  }

  //滚动条的滑块背景色
  ::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 2vh;
  }

  //滚动条的背景色
  ::-webkit-scrollbar-track {
    background: rgba(#ccc, 0.3);
  }

}


/* 设置滚动条的样式 */
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}


/*定义滚动条轨道 内阴影+圆角*/

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  background-color: #F5F5F5;
}


/*定义滑块 内阴影+圆角*/

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
  background-color: #ccc;

}

</style>
